import { useIsDesktop } from '@/_hooks/useBreakpoint';
import { ISavedBranch } from '@/_store/types'

import BranchesMapDesktop from './branches.desktop'
import BranchesMapMobile from './branches.mobile'
import { DialogContent, DialogRoot, DialogCloseTrigger } from '@/components/ui/dialog'

export default function BranchesMap({ open, onClose, onChange }: { open: boolean, onClose: () => void, onChange: (branch: ISavedBranch) => void }) {
  const isDesktop = useIsDesktop()

  if (isDesktop) {
    return <DialogRoot
      size='md'
      lazyMount
      open={open}
      placement={'center'}
      onOpenChange={onClose}
    >
      <DialogContent
        p={0}
        w={'full'}
        rounded={12}
        display='flex'
        flexDir='column'
        overflow={'hidden'}
        h={'532px'}
        maxW={'1200px'}
      >
        <BranchesMapDesktop onClose={onClose} onChange={onChange} />
        <DialogCloseTrigger
          top={8}
          right={8}
          zIndex={1}
          width={10}
          height={10}
          color='text'
          rounded='full'
          bgColor='light'
          boxShadow='4px 4px 12px 0px #00000029'
        />
      </DialogContent>
    </DialogRoot>
  }

  return <DialogRoot size='full' lazyMount open={open} trapFocus={false}>
    <DialogContent display='flex' flexDir='column'>
      <BranchesMapMobile onClose={onClose} onChange={onChange} />
    </DialogContent>
  </DialogRoot>
}
